"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearResultVehicleIds = exports.addResultVehicleIds = exports.setResultVehicleIds = exports.DELETE_RESULT_VEHICLE_IDS = exports.SET_RESULT_VEHICLE_IDS = exports.ADD_RESULT_VEHICLE_IDS = exports.RESULT_VEHICLE_IDS = void 0;
exports.RESULT_VEHICLE_IDS = '[result Vehicle IDs]';
exports.ADD_RESULT_VEHICLE_IDS = `${exports.RESULT_VEHICLE_IDS} ADD`;
exports.SET_RESULT_VEHICLE_IDS = `${exports.RESULT_VEHICLE_IDS} SET`;
exports.DELETE_RESULT_VEHICLE_IDS = `${exports.RESULT_VEHICLE_IDS} DELETE`;
const setResultVehicleIds = ({ vehicleIds }) => ({
    type: exports.SET_RESULT_VEHICLE_IDS,
    payload: vehicleIds,
    meta: { feature: exports.RESULT_VEHICLE_IDS },
});
exports.setResultVehicleIds = setResultVehicleIds;
const addResultVehicleIds = ({ vehicleIds }) => ({
    type: exports.ADD_RESULT_VEHICLE_IDS,
    payload: vehicleIds,
    meta: { feature: exports.RESULT_VEHICLE_IDS },
});
exports.addResultVehicleIds = addResultVehicleIds;
const clearResultVehicleIds = () => ({
    type: exports.DELETE_RESULT_VEHICLE_IDS,
    payload: [],
    meta: { feature: exports.RESULT_VEHICLE_IDS },
});
exports.clearResultVehicleIds = clearResultVehicleIds;
//# sourceMappingURL=resultVehicleIds.js.map